import { AxiosInstance, AxiosRequestConfig } from 'axios';
import Config from 'config/config';
import { BaseClient } from './_baseClient';

const singleton         = Symbol();
const singletonEnforcer = Symbol();
const { api }           = Config;

class CTrackerAPIClient extends BaseClient {
    private constructor(enforcer) {
        super();

        try {
            if (enforcer !== singletonEnforcer) {
                throw new Error('Cannot construct singleton');
            }

            this._baseURL = api.trackerApiDomain;
            this._config  = {};
            this._initSession();
        } catch (e: unknown) {
            console.error(e);
        }
    }

    static get instance(): CTrackerAPIClient & AxiosInstance {
        // Try to get an efficient singleton
        if (!this[singleton]) {
            this[singleton] = new CTrackerAPIClient(singletonEnforcer);
        }

        return this[singleton];
    }
}

export const TrackerAPIClient = CTrackerAPIClient.instance;
